module.exports = __webpack_public_path__ + "img/26.a6d3d7a4.jpg";